export default __webpack_public_path__ + "static/media/pioneer4.12ae5ba9.jpeg";